export const userroles = {
	access: [
		{
			type: "owner",
			label: "Owner",
			description:
				"Only one user can be the Owner, who is the primary contact for the account. The Owner can perform all of the same actions as Admins."
		},
		{
			type: "admin",
			label: "Admin",
			description:
				"Admins can perform all actions on the account. They can create, edit and delete listings and view reports on listing performance. Admins can also set and manage billing info, and invite other users."
		},
		{
			type: "manager",
			label: "Listing manager",
			description:
				"Managers can create, edit and delete listings and view reports on listing performance. They can't view billing information or invite users."
		},
		{
			type: "editor",
			label: "Listing editor",
			description:
				"Editors can only make changes to listings that they have been given access to. They can't view reports, billing information or invite users."
		},
		{
			type: "vacancy-editor",
			label: "Vacancy editor",
			description:
				"Vacancy editors can view and update vacancies for the selected listings."
		},
		{
			type: "report",
			label: "Report viewer",
			description:
				"Report viewers can see reports for the organisation and all listings."
		}
	],
	connect: [
		{
			type: "connect-team-leader",
			label: "Team Leader",
			description:
				"Team leaders can search, save shortlists, send enquiries and view reports on their team's activity. They can't view billling information or invite users."
		},
		{
			type: "connect-case-manager",
			label: "Team Member",
			description:
				"Team members can search, save shortlists, send enquiries and view reports only on their activity. They can't view billing information or invite users"
		},
		{
			type: "care-coordinator",
			label: "Care Coordinator",
			description:
				"Care Coordinators can search, save shortlists, send enquiries and view reports on their team's activity. They can't view billing information or invite users"
		}
	],
	consumer: [
		{
			type: "consumer",
			label: "Dailycare user",
			description: null
		}
	],
	data: [
		{
			type: "dailydata-general",
			label: "DailyData user",
			description: null
		}
	]
};
